import React, {useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import AppLayout from './components/AppLayout';

import Login from './components/Login';
import RiskCategoryManager from './components/risk-categories/RiskCategoryManager';
import RiskListingView from './components/risks/RiskListingView';
import RiskEntryForm from './components/risks/RiskEntryForm';
import RiskDetailView from './components/risks/RiskDetailView';
import GBApprovalDashboard from './components/approval/GBApprovalDashboard';
import SMTApprovalDashboard from './components/approval/SMTApprovalDashboard';
import ApprovalHistoryTracker from './components/approval/ApprovalHistoryTracker';
import MeetingIntegration from './components/meetings/MeetingIntegration';
import RiskAnalyticsDashboard from './components/analytics/RiskAnalyticsDashboard';
import AuditTrail from './components/audit/AuditTrail';
import DocumentManagement from './components/documents/DocumentManagement';
import UserManagement from './components/users/UserManagement';
import CustomReporting from './components/reporting/CustomReporting';
import SystemIntegration from './components/integration/SystemIntegration';
import Dashboard from './components/dashboard/Dashboard';



const App = () => {

  useEffect(() => {
    document.title = 'Summit Risk Register'
}, []);
  
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }>
            {/* Redirect root to dashboard */}
            { <Route index element={<Navigate to="/dashboard" replace />} /> }
            
            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />
            
            <Route path="/risks" element={<RiskListingView />} />
              <Route path="/risks/new" element={<RiskEntryForm />} />
              <Route path="/risks/:riskCode" element={<RiskDetailView />} />
              <Route path="/risks/:riskCode/edit" element={<RiskEntryForm />} />
              <Route path="/risks/categories" element={<RiskCategoryManager />} />
              
              {/* Approval Routes */}
              <Route path="/approvals/smt" element={<SMTApprovalDashboard />} />
              <Route path="/approvals/gb" element={<GBApprovalDashboard />} />
              <Route path="/governance/history" element={<ApprovalHistoryTracker />} />
              <Route path="/governance/schedule" element={<MeetingIntegration />} />
              
              {/* Report Routes */}
              <Route path="/reports/audit" element={<AuditTrail />} />
              <Route path="/reports/changes" element={<AuditTrail initialView="changes" />} />
              <Route path="/reports/analytics" element={<RiskAnalyticsDashboard />} />
              <Route path="/reports/custom" element={<CustomReporting />} />
              
              {/* Document Routes */}
              <Route path="/documents/view" element={<DocumentManagement initialView="view" />} />
              <Route path="/documents/upload" element={<DocumentManagement initialView="upload" />} />
              <Route path="/documents/categories" element={<DocumentManagement initialView="categories" />} />
              
              {/* Settings Routes */}
              <Route path="/settings/users" element={<UserManagement initialView="users" />} />
              <Route path="/settings/roles" element={<UserManagement initialView="roles" />} />
              <Route path="/settings/system" element={<UserManagement initialView="system" />} />

              <Route path="/settings/integration" element={<SystemIntegration initialView="import-export" />} />
              <Route path="/settings/api" element={<SystemIntegration initialView="api" />} />
              
          </Route>

          {/* Catch all route - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
